import { createFileRoute } from '@tanstack/react-router';
import { DEFAULT_API_DOCUMENT } from '../../../api-docs/api-docs-page.tsx';
import { ApiDocsRoute } from '../../../api-docs/api-docs-route.tsx';

// The documentation opens on the receiver contract, the API a participant's backend calls first.
export const Route = createFileRoute('/documentacao/')({
  component: () => <ApiDocsRoute api={DEFAULT_API_DOCUMENT} />,
});
